import { render, staticRenderFns } from "./SetPswAction.vue?vue&type=template&id=1130a819&"
import script from "./SetPswAction.vue?vue&type=script&lang=js&"
export * from "./SetPswAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports